import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Log } from 'src/interfaces/log';

interface DialogData{
  title: string;
  message: string;
  log: Log;
}

enum _EntityType {
  Address = "Address",
  Batch = "Batch",
  BatchItem = "BatchItem",
  BatchStatus = "BatchStatus",
  Company = "Company",
  CompanyType = "CompanyType",
  DeliveryType = "DeliveryType",
  DosageType = "DosageType",
  DosageUnit = "DosageUnit",
  Individual  = "Individual",
  IndividualType = "IndividualType",
  Log = "Log",
  Medicine = "Medicine",
  MedicineDosagePackageType = "MedicineDosagePackageType",
  Order = "Order",
  OrderItem = "OrderItem",
  OrderItemStatus  = "OrderItemStatus",
  PackageType = "PackageType",
  ShippingDetails = "ShippingDetails",
  TrackingDetails = "TrackingDetails",
  UserProfile = "UserProfile",
}

@Component({
    selector: 'app-log-view-dialog',
    templateUrl: './log-view-dialog.component.html',
    styleUrls: ['./log-view-dialog.component.scss'],
    standalone: false
})
export class LogViewDialogComponent implements OnInit {

  EntityType = _EntityType;

  entityTypes: _EntityType [] = [
    _EntityType.Address,
    _EntityType.Batch,
    _EntityType.BatchItem,
    _EntityType.BatchStatus,
    _EntityType.Company,
    _EntityType.CompanyType,
    _EntityType.DeliveryType,
    _EntityType.DosageType, 
    _EntityType.DosageUnit,
    _EntityType.Individual,
    _EntityType.IndividualType,
    _EntityType.Log,
    _EntityType.Medicine,
    _EntityType.MedicineDosagePackageType,
    _EntityType.Order,
    _EntityType.OrderItem,
    _EntityType.OrderItemStatus,
    _EntityType.PackageType,
    _EntityType.ShippingDetails,
    _EntityType.TrackingDetails,
    _EntityType.UserProfile
  ];

  oldValue: any = {};
  newValue: any = {};
  constructor(
    public _dialogRef: MatDialogRef<LogViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    // hello world
    this.oldValue = JSON.parse(this.data.log.old_value);
    this.newValue = JSON.parse(this.data.log.new_value);
  }

}
